<template>
  <div class="mb-12">
    <v-expansion-panels v-model="panel" multiple focusable class="mt-4">
      <v-expansion-panel readonly>
        <v-expansion-panel-header hide-actions>
          <v-row no-gutters class="text-center">
            <v-col cols="2" class="font-weight-bold text-left">Operador</v-col>
            <v-col cols="2" class="font-weight-bold text-left ml-n2"
              >Tempo Online</v-col
            >
            <v-col cols="2" class="font-weight-bold text-left ml-n1"
              >Tempo Disponível</v-col
            >
            <v-col cols="2" class="font-weight-bold text-left ml-n1"
              >Tempo Pausado</v-col
            >
            <v-col cols="2" class="font-weight-bold text-left ml-n1"
              >Tempo em Ligação</v-col
            >
          </v-row>
        </v-expansion-panel-header>
      </v-expansion-panel>

      <v-expansion-panel v-for="(operador, key) in dadosOperadores" :key="key">
        <v-expansion-panel-header ripple>
          <v-row class="text-center" no-gutters>
            <v-col cols="2" class="text-left">{{ operador.operador }}</v-col>
            <v-col cols="2" class="text-left">{{ operador.horaOnline }}</v-col>
            <v-col cols="2" class="text-left">{{
              operador.horaDisponivel
            }}</v-col>
            <v-col cols="2" class="text-left">{{ operador.horaPausado }}</v-col>
            <v-col cols="2" class="text-left">{{
              operador.horasEmLigacao
            }}</v-col>
          </v-row>
          <template v-slot:actions>
            <v-icon color="orangePcm">$expand</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="background">
          <ResumeDisponibilidade :operador="operador" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import ResumeDisponibilidade from "./ResumeDisponibilidade";

export default {
  name: "ExpandList",
  components: { ResumeDisponibilidade },
  props: ["dadosOperadores", "panel"],
};
</script>
